/**
 * /api/licenses — licens-info för aktiv tenant.
 *
 * GET returnerar verifierad licensfil-state (LIC-103) med fallback till
 * legacy DB-licens. POST tar emot signerad .lic-content som base64url-string,
 * verifierar Ed25519-signaturen och persisterar (LIC-105).
 */

import { http } from './httpClient';

export async function getLicense({ tenantId } = {}) {
  const result = await http.get('/licenses', { tenantId });
  return result.data;
}

/**
 * Ladda upp ny licensfil. Innehållet ska vara raw .lic-content
 * (base64url-encoded JSON som scripts/issue-license.js producerar).
 *
 * Backend verifierar signaturen INNAN persistering. Vid ogiltig signatur
 * kastas HttpError med code "validation_error" och details.code = "invalid_signature".
 *
 * @param {string} licenseEncoded - filinnehåll (trim:as automatiskt på server)
 * @param {object} opts
 * @returns {Promise<{state, customer, tenantId, modules, maxUsers, expiresAt}>}
 */
export async function uploadLicense(licenseEncoded, opts = {}) {
  const result = await http.post('/licenses', { licenseEncoded }, opts);
  return result.data;
}
